import circleExclamationIcon from '@/core/svg/fa/circle-exclamation.svg';
import circleInfoIcon from '@/core/svg/fa/circle-info.svg';
import circleQuestionIcon from '@/core/svg/fa/circle-question.svg';
export function getIconByName(variant) {
    switch (variant) {
        case 'question':
            return circleQuestionIcon;
        case 'info':
            return circleInfoIcon;
        case 'exclamation':
            return circleExclamationIcon;
        default: {
            throw new Error(`Unhandled ConfirmationDialogIconVariant case: ${variant}`);
        }
    }
}
